import { useEffect, useState } from "react";
import InputIconSearchPanelMultiSelection from "./InputIconSearchPanelMultiSelection";
import Tag from "./Tag";
import DropdownFilter from "./DropdownFilter";
import { post } from "../js/post";
import { focusElement, userData } from "../js/utils";
import { useOptics } from "../hooks/useOptics";
import { useSuppliers } from "../hooks/useSuppliers";

export function DashboardStorePanelFilterSection({ onChange }) {
  const opticalList = useOptics();
  const [selectedFamily, setSelectedFamily] = useState({ id: "", text: "" });
  const supplierList = useSuppliers(selectedFamily.id)[0];
  const [brandList, setBrandList] = useState([]);
  const [selectedOpticalList, setSelectedOpticalList] = useState([]);
  const [selectedOpticalIdList, setSelectedOpticalIdList] = useState([]);
  const [selectedSupplierIdList, setSelectedSupplierIdList] = useState([]);
  const [selectedSupplierList, setSelectedSupplierList] = useState([]);
  const [selectedBrandList, setSelectedBrandList] = useState([]);

  const getBrands = async () => {
    const response = await post("ListarMarcasProveedores.php", {
      token: userData.token,
      familia: selectedFamily.id,
      proveedores: selectedSupplierIdList,
    });
    setBrandList(response);
  };

  const resetFilters = () => {
    setSelectedFamily({ id: "", text: "" });
    setSelectedOpticalList([]);
    setSelectedSupplierList([]);
    setBrandList([]);
    setSelectedBrandList([]);
  };

  useEffect(() => {
    if (selectedFamily.id !== "") getBrands();
  }, [selectedSupplierIdList]);

  useEffect(() => {
    setSelectedSupplierIdList(
      selectedSupplierList
        .map((nombre) => {
          const found = supplierList.find((s) => s.nombre === nombre);
          return found ? found.id : null;
        })
        .filter((id) => id !== null),
    );
  }, [selectedSupplierList]);

  useEffect(() => {
    setSelectedOpticalIdList(
      selectedOpticalList
        .map((op) => {
          const found = opticalList.find((s) => s.text === op);
          return found ? found.id : null;
        })
        .filter((id) => id !== null),
    );
  }, [selectedOpticalList]);

  useEffect(() => {
    setSelectedSupplierList(
      selectedSupplierList.filter((e) => supplierList.includes(e)),
    );
  }, [supplierList]);

  useEffect(() => {
    setSelectedBrandList(
      selectedBrandList.filter((e) => brandList.includes(e)),
    );
  }, [brandList]);

  useEffect(() => {
    onChange({
      familia: selectedFamily.id,
      opticas: selectedOpticalIdList,
      proveedores: selectedSupplierIdList,
      marcas: selectedBrandList,
    });
  }, [
    selectedFamily,
    selectedOpticalIdList,
    selectedSupplierIdList,
    selectedBrandList,
  ]);

  return (
    <div className="dashboard-section">
      <div className="dashboard-section-title">
        <div className="opt-table-title opt-table-title-dash-stats">
          Filtros comunes
        </div>
        <button
          className="cell-label"
          style={{ width: "120px" }}
          tabIndex={-1}
          onClick={resetFilters}
        >
          Limpiar filtros
        </button>
      </div>
      <div className="dashboard-sec-filters">
        <div className="store-col-sec" style={{ width: "50%" }}>
          <div className="data-field">
            <span className="label">Familia</span>
            <DropdownFilter
              size={0}
              disabled={false}
              optionList={[
                { id: 0, text: "AUDÍFONOS", active: selectedFamily.id === 0 },
                { id: 1, text: "LENTES", active: selectedFamily.id === 1 },
                {
                  id: 2,
                  text: "LENTES DE CONTACTO",
                  active: selectedFamily.id === 2,
                },
                { id: 3, text: "LÍQUIDOS", active: selectedFamily.id === 3 },
                { id: 4, text: "MONTURAS", active: selectedFamily.id === 4 },
                { id: 5, text: "VARIOS", active: selectedFamily.id === 5 },
                { id: 6, text: "SOL", active: selectedFamily.id === 6 },
              ]}
              op={selectedFamily.text}
              selectedOptions={[]}
              onChange={(e) => {
                setSelectedFamily(e);
                focusElement(10);
              }}
            ></DropdownFilter>
          </div>
          <div className="tag-content"></div>
          <div className="data-field">
            <span className="label">Ópticas</span>
            <InputIconSearchPanelMultiSelection
              size={0}
              tabIndex={10}
              inactive={selectedFamily.id === ""}
              type={"type-alphanum-ext"}
              options={opticalList.map((e) => e.text)}
              selectedOptions={selectedOpticalList}
              onChange={(e) => {
                setSelectedOpticalList(e);
              }}
            ></InputIconSearchPanelMultiSelection>
          </div>
          {selectedOpticalList.length > 0 && (
            <span style={{ fontWeight: "500", fontSize: 13 }}>
              Ópticas seleccionadas: {selectedOpticalList.length}
            </span>
          )}
          <div className="tag-content">
            {selectedOpticalList.map((e, i) => {
              return (
                <Tag
                  text={e}
                  key={i}
                  tagId={i}
                  onClick={(e) => {
                    setSelectedOpticalList((prev) =>
                      prev.filter((element) => element !== e),
                    );
                  }}
                ></Tag>
              );
            })}
          </div>
        </div>
        <div className="store-col-sec" style={{ width: "50%" }}>
          <div className="data-field">
            <span className="label">Proveedores</span>
            <InputIconSearchPanelMultiSelection
              size={0}
              tabIndex={11}
              inactive={selectedFamily.id === ""}
              type={"type-alphanum-ext"}
              options={supplierList.map((e) => e.nombre)}
              selectedOptions={selectedSupplierList}
              onChange={(e) => {
                setSelectedSupplierList(e);
              }}
            ></InputIconSearchPanelMultiSelection>
          </div>
          {selectedSupplierList.length > 0 && (
            <span style={{ fontWeight: "500", fontSize: 13 }}>
              Proveedores seleccionadas: {selectedSupplierList.length}
            </span>
          )}
          <div className="tag-content">
            {selectedSupplierList.map((e, i) => {
              return (
                <Tag
                  text={e}
                  key={i}
                  tagId={i}
                  onClick={(e) => {
                    setSelectedSupplierList((prev) =>
                      prev.filter((element) => element !== e),
                    );
                  }}
                ></Tag>
              );
            })}
          </div>
          <div className="data-field">
            <span className="label">Marcas</span>
            <InputIconSearchPanelMultiSelection
              size={0}
              tabIndex={12}
              inactive={selectedFamily.id === ""}
              type={"type-alphanum-ext"}
              options={brandList}
              selectedOptions={selectedBrandList}
              onChange={(e) => {
                setSelectedBrandList(e);
              }}
            ></InputIconSearchPanelMultiSelection>
          </div>
          {selectedBrandList.length > 0 && (
            <span style={{ fontWeight: "500", fontSize: 13 }}>
              Marcas seleccionadas: {selectedBrandList.length}
            </span>
          )}
          <div className="tag-content">
            {selectedBrandList.map((e, i) => {
              return (
                <Tag
                  text={e}
                  key={i}
                  tagId={i}
                  onClick={(e) => {
                    setSelectedBrandList((prev) =>
                      prev.filter((element) => element !== e),
                    );
                  }}
                ></Tag>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
